import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule, Search, Bell, User, Settings, Mail, LogOut } from 'lucide-angular';
import { AuthService } from '../../../services/api/auth/auth.service';
import { NotificationService } from '../../../services/api/notifications/notification.service';

interface NavItem {
  label: string;
  path: string | null;
}

@Component({
  selector: 'cf-site-header',
  imports: [RouterLink, RouterLinkActive, LucideAngularModule],
  templateUrl: './site-header.html',
  styleUrl: './site-header.scss',
  host: {
    '(document:click)': 'closeMenu()'
  },
  providers: [NotificationService]
})
export class SiteHeader {
  private readonly router = inject(Router);
  readonly auth = inject(AuthService);

  // Only Home is routed so far; the rest light up as their pages get built.
  readonly navItems: NavItem[] = [
    { label: 'Home', path: '/' },
    { label: 'Forums', path: '/forums' }
  ];

  readonly icons = { Search, Bell, User, Settings, Mail, LogOut };

  private readonly summary = toSignal(inject(NotificationService).getSummary());

  notifications = computed(() => this.summary()?.notificationCount ?? 0);
  messages = computed(() => this.summary()?.messageCount ?? 0);
  status = computed(() => this.auth.currentUser()?.status ?? 'online');

  menuOpen = signal(false);
  signedIn = computed(() => this.auth.currentUser() !== null);

  toggleMenu(event: Event): void {
    event.stopPropagation();
    this.menuOpen.update(open => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  signOut(event: Event): void {
    event.preventDefault();
    this.auth.signOut();
    this.router.navigateByUrl('/login');
  }
}
